export const BackgroundLinearGradient = () => {
  return (
    <div className="absolute inset-0 bg-[linear-gradient(305deg,rgba(0,0,0,0.25)_10%,rgba(0,0,0,0.45)_100%)] md:bg-[linear-gradient(305deg,rgba(0,0,0,0.25)_10%,rgba(0,0,0,0.45)_100%)]" />
  )
}
